import { createFileRoute } from "@tanstack/react-router";
import { AdServiceLanding } from "@/components/ads/AdServiceLanding";
import herrklippningAsset from "@/assets/opt/herrklippning-tailors-barber.webp";
export const Route = createFileRoute("/barberare-stockholm-ahlens-city/herrklippning")({
  head: () => ({
    meta: [
      { title: "Herrklippning Stockholm City · 450 kr | Tailor's Barber Åhléns" },
      { name: "description", content: "Herrklippning i Stockholm City för 450 kr inkl. konsultation, klippning och styling. Boka hos Tailor's Barber Åhléns City – 1 min från T-Centralen." },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: () => (
    <AdServiceLanding
      reviewService="herrklippning"
      heroImage={herrklippningAsset}
      heroImageAlt="Herrklippning hos Tailor's Barber Åhléns City Stockholm"
      eyebrow="Tailor's Barber · Åhléns City · 1 min från T-Centralen"
      h1="Herrklippning i Stockholm City"
      priceBadge="450 kr"
      salon="ahlens-city"
      primaryCtaLabel="Boka Herrklippning →"
      primaryCtaHref="https://www.bokadirekt.se/boka-tjanst/tailors-barber-stockholm-ahlens-city-37678/klippning-1247219?utm_source=google&utm_medium=cpc&utm_campaign=ahlens-city"
      secondary="Drop-in välkommen i mån av tid"
      included={[
        { title: "Konsultation", desc: "Din hårtyp, ansiktsform, livsstil." },
        { title: "Herrklippning", desc: "Klassisk eller modern, sax eller maskin." },
        { title: "Hårtvätt & styling", desc: "Avslutas med Tailor's Grooming produkter." },
        { title: "Underhållstips", desc: "Råd för att hålla frisyren längre." },
      ]}
      priceBox="Herrklippning: 450 kr · inkl. konsultation, klippning & styling"
      faq={[
        { q: "Vad ingår i en herrklippning?", a: "Konsultation, klippning med sax och/eller maskin, hårtvätt och styling med produkter." },
        { q: "Hur lång tid tar det?", a: "30–40 minuter." },
        { q: "Kan jag välja vilken barberare jag vill?", a: "Ja, välj din favoritbarberare vid bokning online." },
        { q: "Tar ni drop-in?", a: "Ja, i mån av tid. Tidig förmiddag har kortast väntetid." },
      ]}
    />
  ),
});
